<template>
  <div>
    <div class="page page__list" v-if="!isChange">
      <search-bar
        @search="onSearch"
        name="de_name,de_product_type,de_code"
        placeholder="输入需求单号、项目名称进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.de_id"
          :to="'/plm/demand/' + item.de_id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.de_code }}</p>
            <p class="list-item-muted">{{ item.createTime }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.de_name }}&nbsp;{{ item.de_product_type }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.de_status != '已审核' }"
              >{{ item.de_status }}</span
            >
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}单</label>
      </div>
      <add-button to="/plm/demand_edit" />
    </div>
    <div class="page page__list" v-if="isChange">
      <search-bar
        @search="onSearch"
        name="dc_decode,dc_code"
        placeholder="输入变更单号、需求单号进行查找"
        ref="searchBar"
      />
      <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/plm/demand_change/' + item.id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.dc_code }}</p>
            <p class="list-item-muted">{{ item.dc_content }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.dc_name_new }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.dc_status != '已审核' }"
            >
              {{ item.dc_status }}
            </span>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ items.length }}条</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton,
  },
  mixins: [list],
  data() {
    
    const me = this,
      beforeChange = me.beforeFilterChange;
    return {
      isChange: false,
      listUrl: "/api/plm/demand/list",
      filters: [
        {
          type: "date",
          name: "plm_demand.createTime",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          beforeChange,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "de_status='未审核'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "de_status='已审核'",
            },
            {
              value: 3,
              label: "待变更",
              condition: "dc_statuscode='SUBMITTED'",
            },
            {
              value: 4,
              label: "已变更",
              condition: "dc_statuscode='AUDITED'",
            },
          ],
        },
      ],
    };
  },
  methods: {
    beforeFilterChange(filter, filterBar, next) {
      
      let isChange = filter.value > 2;
      this.listUrl = isChange
        ? "/api/plm/demandChange/list"
        : "/api/plm/demand/list";
      this.filters[0].name = isChange ? "createTime" : "plm_demand.createTime";
      this.isChange = isChange ? true : false;
      filterBar.initConfig();
      next();
    },
  },
};
</script>